import { ImageSquare } from "@/icons";
import { Icon, Surface, SurfaceProvider, Text } from "@/components/ui";
import { cn } from "@/lib/cn";

interface NoImageProps {
  alt?: string;
  width?: number;
  height?: number;
  className?: string;
}

/** Placeholder for a missing photo: a themed glyph that follows the merchant palette; sized by `className`. */
export const NoImage = ({
  alt,
  className,
}: NoImageProps) => {
  return (
    <Surface
      surface="page"
      role="img"
      aria-label={alt ?? "Sem imagem"}
      className={cn("flex items-center justify-center ", className)}
    >
      <SurfaceProvider surface="page">
        <Text as="span" tone="disabled" className="flex h-1/2 w-1/2 max-h-12 max-w-12 items-center justify-center">
          <Icon as={ImageSquare} size="4xl" className="h-full w-full" />
        </Text>
      </SurfaceProvider>
    </Surface>
  );
};
